/* Static pages capture campaign data without booting a React island.
Account sync runs when the visitor enters the hydrated app. */
import { captureCurrentAttribution } from "@/lib/acquisition-attribution";
import { BRAND } from "@/lib/brand";
import { initWhopPixel } from "@/lib/whop-pixel";
import { initXPixel } from "@/lib/x-pixel";
captureCurrentAttribution();
if (new URLSearchParams(window.location.search).has("twclid")) {
	initXPixel();
}
initWhopPixel(BRAND.whopPixelScope);